<template class="">
 <!-- Navigation Header -->
 
<div style="min-height: 100vh;">
 <router-view ></router-view>
</div>

</template>
<script>
  export default {
    data(){
      return{
        menuOpen: false,
        isScrolled: false
      }
    },
    components: {
    },
    name: "WebLayout2",
    created(){

    },

    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      const expiretime = 7; // days
      const cookiesLang = this.$cookies.get('lang');
      if (cookiesLang) {
        this.$i18n.locale = cookiesLang;
        if(cookiesLang=='ar'){
          $('body').addClass('rtl');
        }
        else{
          $('body').removeClass('rtl');
        }
      } else {
        this.$cookies.set('lang', this.$i18n.locale, expiretime);
      }
    },
    
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods:{
      changeLang(){
        if(this.$i18n.locale=='en'){
          this.$i18n.locale='ar';
          $('body').addClass('rtl');
          this.$cookies.set('lang', 'ar', 7);
        }
        else{
          this.$i18n.locale='en';
          $('body').removeClass('rtl');
          this.$cookies.set('lang', 'en', 7);
        }
      },
      close(stauts){
        if(stauts==0){
          this.$store.state.showPopUp=false;
        }
        else{
          this.$store.state.showPopUp=false;
          this.$router.push({ name: 'homepage' });
        }
      },
      toggleMenu() {
        this.menuOpen = !this.menuOpen
        if (this.menuOpen) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },
      closeMenu() {
        this.menuOpen = false
        document.body.style.overflow = ''
      },
      handleScroll() {
        this.isScrolled = window.scrollY > 50
      }
    },
  }
</script>

<style scoped>
/* Global Overflow Fix */
:global(body) {
  overflow-x: hidden;
  max-width: 100vw;
}

/* Navbar Styles */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 20px 0;
  transition: all 0.3s ease;
  /* background: rgba(63, 36, 22, 0.3);
  backdrop-filter: blur(10px); */
}

.navbar.scrolled {
  /* background: rgba(63, 36, 22, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0; */
}
.navbar.scrolled .navbar-content {
  background: rgba(63, 36, 22, 0.5);
}

/* .navbar .container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
  width: 100%;
} */

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* background: rgba(255, 255, 255, 0.1); */
  background: rgba(63, 36, 22, 0.4);

  border-radius: 200px;
  padding: 15px 50px;
  backdrop-filter: blur(16px);
}

.logo img {
  height: 50px;
  width: auto;
}

.nav-menu {
  display: flex;
  align-items: center;

  gap: 45px;
}

.nav-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
  font-weight: 400;
  transition: opacity 0.3s ease;
  letter-spacing: 0.3px;
}

.nav-link:hover {
  opacity: 0.8;
}

.nav-cta-btn {
  background: #8B5A3C;
  color: #ffffff;
  border: none;
  padding: 14px 32px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.lang-btn{
  padding:10px 15px;
}

.nav-cta-btn:hover {
  background: #6d4530;
  transform: translateY(-2px);
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  z-index: 1001;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.mobile-cta {
  display: none;
}

.desktop-cta {
  display: block;
}
@media (max-width: 1280px) {
  .navbar-content{
    padding: 12px 25px;
  }
  .nav-menu{
    gap: 20px;
  }
  
}
/* Responsive Navbar */
@media (max-width: 1024px) {
  .navbar {
    background: rgba(63, 36, 22, 0.95);
    padding: 15px 0;
  }
   .hamburger {
    display: flex;
  }

  /* .navbar .container {
    padding: 0 40px;
  } */

  .navbar-content {
    /* padding: 12px 30px; */
    background: rgba(255, 255, 255, 0.08);
  }

  

  .desktop-cta {
    display: none;
  }

  .nav-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: #3F2416;
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 15px;
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3);
    visibility: hidden;
  }

  .nav-menu.active {
    right: 0;
    visibility: visible;
  }

  .nav-link {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 15px;
  }

  .mobile-cta {
    display: block;
    width: 100%;
    margin-top: 15px;
    padding: 12px 24px;
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  /* .navbar .container {
    padding: 0 15px;
  } */

  .navbar-content {
    padding: 10px 20px;
    border-radius: 100px;
  }

  .logo img {
    height: 40px;
  }

  .nav-link {
    padding: 8px 0;
    font-size: 14px;
  }

  .mobile-cta {
    padding: 10px 20px;
    font-size: 14px;
    margin-top: 10px;
  }
}

@media (max-width: 1024px) {
  .navbar {
    background: rgba(63, 36, 22, 0.95);
    padding: 15px 0;
  }

  /* .navbar .container {
    padding: 0 40px;
  } */

  .navbar-content {
    padding: 12px 30px;
    background: rgba(255, 255, 255, 0.08);
  }

  .logo img {
    height: 35px;
  }

  .nav-menu {
    width: 100%;
    right: -100%;
  }

  .hamburger span {
    width: 22px;
  }
}


</style>